export function validateCPF(cpf: string): boolean {
  const cpfClean = cpf.replace(/\D/g, "");

  if (cpfClean.length !== 11) {
    return false;
  }

  // Check for known invalid patterns
  if (/^(\d)\1{10}$/.test(cpfClean)) {
    return false;
  }

  // Validate first digit
  let sum = 0;
  for (let i = 0; i < 9; i++) {
    sum += parseInt(cpfClean.charAt(i)) * (10 - i);
  }

  let remainder = 11 - (sum % 11);
  if (remainder === 10 || remainder === 11) {
    remainder = 0;
  }

  if (remainder !== parseInt(cpfClean.charAt(9))) {
    return false;
  }

  // Validate second digit
  sum = 0;
  for (let i = 0; i < 10; i++) {
    sum += parseInt(cpfClean.charAt(i)) * (11 - i);
  }

  remainder = 11 - (sum % 11);
  if (remainder === 10 || remainder === 11) {
    remainder = 0;
  }

  if (remainder !== parseInt(cpfClean.charAt(10))) {
    return false;
  }

  return true;
}

export function removeCharacters(cpf: string): string {
  return cpf.replace(/\D/g, "");
}

export function validateCEP(cep: string): boolean {
  const cepClean = cep.replace(/\D/g, "");
  return cepClean.length === 8;
}

export function formatCEP(cep: string): string {
  const cepClean = cep.replace(/\D/g, "");
  return cepClean.replace(/(\d{5})(\d{3})/, "$1-$2");
}

export function validateCNPJ(cnpj: string): boolean {
  const cnpjClean = cnpj.replace(/\D/g, "");

  if (cnpjClean.length !== 14) {
    return false;
  }

  // Check for known invalid patterns (all same digits)
  if (/^(\d)\1{13}$/.test(cnpjClean)) {
    return false;
  }

  // Validate first check digit
  let sum = 0;
  let weight = 5;
  for (let i = 0; i < 12; i++) {
    sum += parseInt(cnpjClean.charAt(i)) * weight;
    weight = weight === 2 ? 9 : weight - 1;
  }

  let remainder = sum % 11;
  const firstCheckDigit = remainder < 2 ? 0 : 11 - remainder;

  if (firstCheckDigit !== parseInt(cnpjClean.charAt(12))) {
    return false;
  }

  // Validate second check digit
  sum = 0;
  weight = 6;
  for (let i = 0; i < 13; i++) {
    sum += parseInt(cnpjClean.charAt(i)) * weight;
    weight = weight === 2 ? 9 : weight - 1;
  }

  remainder = sum % 11;
  const secondCheckDigit = remainder < 2 ? 0 : 11 - remainder;

  if (secondCheckDigit !== parseInt(cnpjClean.charAt(13))) {
    return false;
  }


  return true;
}

export function validateDateRange(date: Date | string): boolean {
  const dateObj = typeof date === "string" ? new Date(date) : date;

  if (isNaN(dateObj.getTime())) {
    return false;
  }

  const today = new Date();
  const minDate = new Date();
  minDate.setFullYear(today.getFullYear() - 100);

  const maxDate = new Date();
  maxDate.setFullYear(today.getFullYear() + 20);

  // Reset time part to ensure only date is compared if needed, 
  // but for range usually explicit time might not matter as much if we want rough years.
  // Let's keep it simple: strict timestamp comparison.

  return dateObj >= minDate && dateObj <= maxDate;
}
